var DigitInputsType;
(function (DigitInputsType) {
    DigitInputsType["DOTS"] = "dots";
    DigitInputsType["NUMERIC"] = "numeric";
})(DigitInputsType || (DigitInputsType = {}));
const DIGIT_INPUTS_MAX_SIZE = 8;
export { DIGIT_INPUTS_MAX_SIZE, DigitInputsType, };
//# sourceMappingURL=digit-inputs-constants.js.map